<!--First time mfa enroll link -->
<div class="mfa__container is-fullbleed" *ngIf="hasNoFactorEnroll">
  <div class="mfa__container__col">
    <div class="mfa__container forFirsttimeEnroll">
      <div class="mfa__container__col">
        <section class="mfa__mfa-enroll mfa__mfa-enroll--center" aria-labelledby="mfa-enroll-link">
          <svg
            class="mfa__mfa-enroll__icon"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            x="0px"
            y="0px"
            width="576px"
            height="512px"
            viewBox="0 0 576 512"
            style="enable-background: new 0 0 576 512"
            xml:space="preserve"
            role="img"
            aria-label="Warning icon"
          >
            <path
              class="st0"
              fill="#FFD43B"
              d="M569.5,440c18.5,32-4.7,72-41.6,72H48.1c-36.9,0-60-40.1-41.6-72L246.4,24c18.5-32,64.7-32,83.2,0L569.5,440  L569.5,440z M288,354c-25.4,0-46,20.6-46,46s20.6,46,46,46s46-20.6,46-46S313.4,354,288,354z M244.3,188.7l7.4,136  c0.3,6.4,5.6,11.3,12,11.3h48.5c6.4,0,11.6-5,12-11.3l7.4-136c0.4-6.9-5.1-12.7-12-12.7h-63.4C249.4,176,244,181.8,244.3,188.7  L244.3,188.7z"
            ></path>
          </svg>
          <div class="mfa__mfa-enroll__copy">
            <h1 id="mfa-enroll-link" class="mfa__mfa-enroll__header--light no-margin--bottom">
              <a
                class="mfa__mfa-enroll__link link"
                href="javascript:void(0)"
                (click)="enableEnrollform()"
                aria-label="Update your two-step security to continue"
              >
                Please update your two-step security to continue.
              </a>
            </h1>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

<!--First time mfa enroll link End -->

<!--First time mfa enroll Input page -->
<div class="mfa__container is-fullbleed" *ngIf="enrollForm">
  <div class="mfa__container__col">
    <div class="mfa__container is-slim">
      <div class="mfa__container__col">
        <section
          class="mfa__factor-maintenance mfa__factor-maintenance--enroll js-mfa__mfa-fm"
          aria-labelledby="factor-maintenance-header"
        >
          <div class="mfa__factor-maintenance__copy">
            <h1 id="factor-maintenance-header" class="mfa__section-heading">Change your two-step security details</h1>
            <p class="mfa__sub-heading" aria-live="polite">At least one method must be filled in to continue.</p>
          </div>
          <!-- Single Notification Element -->
          <div class="mfa__factor-maintenance__alert" [ngClass]="notificationStyle">
            <label id="errorMsg" aria-live="assertive" *ngIf="notificationVisible"> {{ notificationText }}</label>
          </div>

          <div class="form-container">
            <form [formGroup]="enrollform" class="form-container2" aria-describedby="form-instructions">
              <!-- Email Block -->
              <div class="form-group test01">
                <label for="email" class="Input-label">Email</label>
                <div class="input-container">
                  <input
                    type="email"
                    [formControlName]="'email'"
                    (input)="InputfieldValueChange($event, 0)"
                    aria-label="Enter your email address"
                    aria-describedby="errorMsg"
                  />
                  <div class="verifiedContact" *ngIf="IsVerifiedContact[0]" aria-live="polite" id="verifyBtnEmail">
                    <input
                      type="checkbox"
                      class="checkboxInput"
                      id="verifiedContactEmail"
                      name="verifiedContact"
                      formControlName="isChecked"
                      (change)="onRemoveUserFactor($event, 0)"
                      aria-label="contact verified"
                    />
                    <span>Contact Verified</span>
                  </div>
                  <button
                    *ngIf="verifyBtnVisible[0]"
                    id="verifyBtnEmail"
                    type="button"
                    class="verify-btn"
                    [disabled]="verifyBtnEnabled[0]"
                    (click)="enrollUerFactorApi(0, $event)"
                    aria-label="Verify contact"
                  >
                    Verify Contact
                  </button>
                </div>
                <div *ngIf="isFieldInvalid[0]" id="email-error" class="isFieldInvalid">
                  <label for="otp" class="Input-label" style="color: red">Invalid Email</label>
                </div>
                <div *ngIf="otpVisible[0]" class="otp-sent-block test01">
                  <label
                    #labelRef
                    tabindex="0"
                    id="securitycodesent"
                    for="otp-email"
                    class="Input-label"
                    role="alert"
                    [attr.aria-describedby]="labelRef.innerText"
                    >We just sent a security code to validate your email</label
                  >
                  <div class="input-container">
                    <input
                      type="otp"
                      [formControlName]="'otp_Email'"
                      [attr.aria-label]="errorMsg_otp_Email_res"
                      aria-describedby="errorMsg"
                    />
                    <button
                      type="button"
                      class="verify-btn"
                      aria-label="Verify Code"
                      [disabled]="verifyCodeBtnEnabled[0]"
                      (click)="activateFactorApi(0, $event)"
                    >
                      Verify Code
                    </button>
                  </div>
                  <button type="button" class="mfa_resend link" aria-label="resend Code" (click)="resendFactor(0)">
                    Resend Code
                  </button>
                </div>
              </div>

              <!-- Text Block -->
              <div class="form-group test02">
                <label for="textSMS" class="Input-label">Text/SMS message</label>
                <div class="input-container">
                  <input
                    type="text"
                    [formControlName]="'text'"
                    (input)="InputfieldValueChange($event, 1)"
                    [attr.aria-invalid]="isFieldInvalid[1]"
                    [attr.aria-label]="errorMsg_Text_SMS"
                    aria-describedby="errorMsg"
                  />
                  <div class="verifiedContact" *ngIf="IsVerifiedContact[1]" aria-live="polite" id="verifyBtnTextSMS">
                    <input
                      type="checkbox"
                      class="checkboxInput"
                      id="verifiedContactText"
                      name="verifiedContact"
                      formControlName="isChecked"
                      (change)="onRemoveUserFactor($event, 1)"
                      aria-label="Text/SMS contact verified"
                    />
                    <span>Contact Verified</span>
                  </div>
                  <button
                    *ngIf="verifyBtnVisible[1]"
                    id="verifyBtnTextSMS"
                    type="button"
                    class="verify-btn"
                    [disabled]="verifyBtnEnabled[1]"
                    (click)="enrollUerFactorApi(1, $event)"
                    aria-label="Verify contact"
                  >
                    Verify Contact
                  </button>
                </div>
                <div *ngIf="isFieldInvalid[1]" id="text-error" class="isFieldInvalid">
                  <label for="otp" class="Input-label" style="color: red">Invalid Phone</label>
                </div>
                <div *ngIf="otpVisible[1]" class="otp-sent-block test02">
                  <label for="otp" class="Input-label" aria-live="polite"
                    >We just sent a security code to validate your text/sms</label
                  >
                  <div class="input-container">
                    <input
                      type="otp"
                      [formControlName]="'otp_text_sms'"
                      [attr.aria-label]="errorMsg_Text_SMS_res"
                      aria-describedby="errorMsg"
                    />

                    <button
                      type="button"
                      class="verify-btn"
                      [disabled]="verifyCodeBtnEnabled[1]"
                      (click)="activateFactorApi(1, $event)"
                    >
                      Verify Code
                    </button>
                  </div>
                  <button type="button" class="mfa_resend link" (click)="resendFactor(1)">Resend Code</button>
                </div>
              </div>

              <!-- Audio Block -->
              <div class="form-group test03">
                <label for="audio" class="Input-label">Phone number for audio verification</label>
                <div class="input-container">
                  <input
                    type="text"
                    id="audio"
                    [formControlName]="'audio'"
                    (input)="InputfieldValueChange($event, 2)"
                    [attr.aria-invalid]="isFieldInvalid[2]"
                    aria-describedby="audio-error"
                    [attr.aria-label]="errorMsg_Voice"
                    aria-describedby="errorMsg"
                  />
                  <div class="verifiedContact" *ngIf="IsVerifiedContact[2]" aria-live="polite" id="verifyBtnAudio">
                    <input
                      type="checkbox"
                      class="checkboxInput"
                      id="verifiedContactAudio"
                      name="verifiedContact"
                      formControlName="isChecked"
                      (change)="onRemoveUserFactor($event, 2)"
                      aria-label="Audio contact verified"
                    />
                    <span>Contact Verified</span>
                  </div>
                  <button
                    *ngIf="verifyBtnVisible[2]"
                    id="verifyBtnAudio"
                    type="button"
                    class="verify-btn"
                    [disabled]="verifyBtnEnabled[2]"
                    (click)="enrollUerFactorApi(2, $event)"
                    aria-label="Verify contact"
                  >
                    Verify Contact
                  </button>
                </div>
                <div *ngIf="isFieldInvalid[2]" id="audio-error" class="isFieldInvalid">
                  <label for="otp" class="Input-label" style="color: red">Invalid Phone</label>
                </div>
                <div *ngIf="otpVisible[2]" class="otp-sent-block test03">
                  <label for="otp" class="Input-label" aria-live="polite"
                    >We just sent a security code to validate your phone</label
                  >
                  <div class="input-container">
                    <input
                      type="otp"
                      [formControlName]="'otp_audio'"
                      [attr.aria-label]="errorMsg_Voice_res"
                      aria-describedby="errorMsg"
                    />
                    <button
                      type="button"
                      class="verify-btn"
                      [disabled]="verifyCodeBtnEnabled[2]"
                      (click)="activateFactorApi(2, $event)"
                    >
                      Verify Code
                    </button>
                  </div>
                  <button type="button" class="mfa_resend link" (click)="resendFactor(2)">Resend Code</button>
                </div>
              </div>
            </form>
            <button
              type="button"
              class="mfa_continue-btn"
              [disabled]="isContinueEnabled"
              (click)="OnContinueBtnClick()"
              aria-label="Continue to the next step"
            >
              Continue
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
